import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getIntermediateFileLogs } from 'src/redux/async/rfxManagement/rfpManagementAsync'

const initialState = {
  intermediateFileLogsLoader: false,
  intermediateFileLogsError: '',
  intermediateFileLogsData: [],
}

export const intermediateFileLogsSlice = createSlice({
  name: 'intermediate-file-logs',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getIntermediateFileLogs.pending), (state) => {
      state.intermediateFileLogsLoader = true
      state.intermediateFileLogsData = []
    })
    builder.addMatcher(isAnyOf(getIntermediateFileLogs.fulfilled), (state, action) => {
      state.intermediateFileLogsLoader = false
      state.intermediateFileLogsData = action.payload
      state.intermediateFileLogsError = ''
    })
    builder.addMatcher(isAnyOf(getIntermediateFileLogs.rejected), (state, action) => {
      state.intermediateFileLogsLoader = false
      state.intermediateFileLogsError = action.payload
    })
  },
  reducers: {
    emptyIntermediateFileLogs: (state) => {
      state.intermediateFileLogsLoader = false
      state.intermediateFileLogsError = ''
      state.intermediateFileLogsData = []
    },
  },
})

export const { emptyIntermediateFileLogs } = intermediateFileLogsSlice.actions

export default intermediateFileLogsSlice.reducer
